declare namespace $ {

	type __shm_hitalama_dragtree_item_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_dragtree_item['pointerdown'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_dragtree_item['Drag'] >['pointerdown'] >[0]
	>
	type $shm_hitalama_dragtree_drag__use_buttons_shm_hitalama_dragtree_item_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['buttons'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['use_buttons'] >
	>
	type $shm_hitalama_dragtree_drag__on_drag_start_shm_hitalama_dragtree_item_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['on_drag_start'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['on_drag_start'] >
	>
	type $shm_hitalama_dragtree_drag__on_drag_end_shm_hitalama_dragtree_item_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['on_drag_end'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['on_drag_end'] >
	>
	type $shm_hitalama_dragtree_drag__on_drag_shm_hitalama_dragtree_item_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['on_drag'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['on_drag'] >
	>
	type $shm_hitalama_dragtree_drag__y_shm_hitalama_dragtree_item_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['y'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['y'] >
	>
	type $shm_hitalama_dragtree_drag__x_shm_hitalama_dragtree_item_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['x'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['x'] >
	>
	type $shm_hitalama_dragtree_drag__drags_synced_shm_hitalama_dragtree_item_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['drags_synced'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['drags_synced'] >
	>
	type $shm_hitalama_dragtree_drag__repos_x_shm_hitalama_dragtree_item_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['repos_x'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['repos_x'] >
	>
	type $shm_hitalama_dragtree_drag__repos_y_shm_hitalama_dragtree_item_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['repos_y'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['repos_y'] >
	>
	type $shm_hitalama_dragtree_drag__hold_delay_shm_hitalama_dragtree_item_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['hold_delay'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['hold_delay'] >
	>
	type $shm_hitalama_dragtree_drag__hold_move_threshold_shm_hitalama_dragtree_item_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_dragtree_item['hold_move_threshold'] >
		,
		ReturnType< $shm_hitalama_dragtree_drag['hold_move_threshold'] >
	>
	export class $shm_hitalama_dragtree_item extends $shm_hitalama_draglist_item {
		on_drag_start( next?: any ): any
		on_drag_end( next?: any ): any
		on_drag( next?: any ): any
		dragged( ): ReturnType< ReturnType< $shm_hitalama_dragtree_item['Drag'] >['dragged'] >
		y( next?: number ): number
		x( next?: number ): number
		drags_synced( ): readonly($rise_drag)[]
		repos_x( id: any): number
		repos_y( id: any): number
		pointerdown( next?: ReturnType< ReturnType< $shm_hitalama_dragtree_item['Drag'] >['pointerdown'] > ): ReturnType< ReturnType< $shm_hitalama_dragtree_item['Drag'] >['pointerdown'] >
		transition_smooth( ): string
		hold_delay( ): number
		hold_move_threshold( ): number
		buttons( ): readonly(number)[]
		Drag( ): $shm_hitalama_dragtree_drag
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map